import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {FormGroup} from 'arag-ui-lib';
import {FORM_GROUP_VARIANTS} from '../helpers/formGroupVariants';
import CONTENT_STRINGS from '../helpers/contentStrings';
import {LEGAL_ADVICE_TEXT} from '../helpers/variables';
import {formatSolicitorOptionLabel} from '../helpers/functions';
import {requestLawsysFirmsFiltered} from '../actions/lawsysFirms';
import {buildFirmSearchOptions, MIN_FIRM_SEARCH_CHARACTERS} from '../helpers/solicitorFirmSearch';

// Searches every Lawsys firm server-side once 3 characters are typed, so firms with no users are found too.
const SolicitorFirmSearchSelect = (props) => {
    const {label, labelSize, inputSize, instanceId, isMulti, value, onChange, isDisabled, extraOptions, formGroupTestId} = props;
    const dispatch = useDispatch();
    const lawsysFirmsFiltered = useSelector(state => state.lawsysFirms.lawsysFirmsFiltered);
    const fetching = useSelector(state => state.lawsysFirms.fetching);
    const [inputValue, setInputValue] = useState('');
    const searching = inputValue.length >= MIN_FIRM_SEARCH_CHARACTERS;

    useEffect(() => {
        if (!searching) return undefined;
        const askServer = setTimeout(() => dispatch(requestLawsysFirmsFiltered({search: inputValue})), 500);
        return () => clearTimeout(askServer);
    }, [inputValue]); // eslint-disable-line react-hooks/exhaustive-deps

    const onInputChange = (newValue, {action}) => {
        if (action === 'input-change') setInputValue(newValue);
        else if (action === 'input-blur' || action === 'set-value') setInputValue('');
    };

    return (
        <FormGroup
            labelSize={labelSize}
            inputSize={inputSize}
            label={label}
            variant={FORM_GROUP_VARIANTS.SEARCHABLE_LIST}
            inputProps={{
                instanceId,
                inputValue,
                onInputChange,
                onChange: (selected) => onChange(isMulti ? (selected || []) : selected),
                value,
                options: buildFirmSearchOptions(value, searching ? lawsysFirmsFiltered : [], extraOptions),
                isLoading: searching && fetching,
                isMulti: !!isMulti,
                isDisabled,
                placeholder: CONTENT_STRINGS.TYPE_AT_LEAST_3_LETTERS,
                noOptionsText: `${CONTENT_STRINGS.NO} ${LEGAL_ADVICE_TEXT} ${CONTENT_STRINGS.FOUND}`,
                minSearchCharacters: MIN_FIRM_SEARCH_CHARACTERS,
                formatOptionLabel: formatSolicitorOptionLabel,
            }}
            formGroupTestId={formGroupTestId}
        />
    );
};

export default SolicitorFirmSearchSelect;
